
import React, { useState } from 'react';
import './AffiliatePage.css';
import NavigationMenu from './../navigationMenu/navigationMenu';
import Purse from './../purse/purse';
import ButtonVariant from './../buttonVariant/buttonVariant';
import Input from './../input/input';
import CopiBtn from './../copiBtn/copiBtn';
import CopiIcon from '../../img/Copy.png'
import Down from './../down/down';
import ButtonColor from './../buttonColor/buttonColor';

const AffiliatePage = ({ text }) => {
  const [isVariant, setIsVariant] = useState(false);

  return (
    <>
      <div className="">
        <NavigationMenu >
          <Purse title="Партнерская программа">
            {!isVariant ? (
              <>
                <div className="content_navigatino">
                  <div onClick={() => setIsVariant(!isVariant)}>
                    <ButtonVariant name="Партнёрские вознаграждения" isShow={true} />
                  </div>
                  <div onClick={() => setIsVariant(!isVariant)}>
                    <ButtonVariant name="Рефералы" />
                  </div>
                </div>
                <div className="text_affiliatePage">
                  Вы можете участвовать в нашей партнерской программе. Используйте личную ссылку ниже.
                </div>
                <div className="container_input_child">
                  <Input title="Ваша партнерская ссылка " placeholder="https://www.cryptomercgant.com/ref/gmwefrgolrr69" />
                  <CopiBtn src={CopiIcon} />
                </div>
                <Down title="Мои партнёры" >
                  <div className="text">Партнёр 1</div>
                  <div className="text">Партнёр 2</div>
                  <div className="width" >
                    <ButtonColor isVariant={true} name="Load more" />
                  </div>
                </Down>
                <div className="container_margin"></div>
              </>
            ) : (<>
              <div className="content_navigatino">
                <div onClick={() => setIsVariant(!isVariant)}>
                  <ButtonVariant name="Партнёрские вознаграждения" isShow={true} />
                </div>
                <div onClick={() => setIsVariant(!isVariant)}>
                  <ButtonVariant name="Рефералы" />
                </div>
              </div>
              ?????
              <div className="container_margin"></div>
            </>)}
          </Purse>
        </NavigationMenu>
      </div>
    </>

  )
}

export default AffiliatePage;